import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { Pencil, CheckLg, XLg } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";

import Loader from "../components/Loader";
import Message from "../components/Message";
import VerticallyCenteredModal from "../components/SubmitModal";
import { setCredentials } from "../slices/authSlice";

import { toast } from "react-toastify";
import { getCurrentDate, getDateOfLast } from "../utils/getCurrentDate";
import {
  useGetCustomersQuery,
  useUpdateCustomerMutation,
} from "../slices/customerSlice";

const WhatsAppAdsToCustomers = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [editEnabled, setEditEnabled] = useState("");
  const [statusUpdate, setStatusUpdate] = useState("");
  const [customersToDisplay, setCustomersToDisplay] = useState(
    userInfo?.allCustomers || []
  );
  const [modalShow, setModalShow] = useState(false);
  const [adStatus, setAdStaus] = useState("Not Sent");
  const [startPincode, setStartPincode] = useState(
    userInfo?.customersStartPincode ? userInfo?.customersStartPincode : 600000
  );
  const [endPincode, setEndPincode] = useState(
    userInfo?.customersEndPincode ? userInfo?.customersEndPincode : 700000
  );
  const [startDate, setStartDate] = useState(getDateOfLast(1000));

  const [endDate, setEndDate] = useState(getCurrentDate());
  const [whatsAppAppNa, setWhatsAppAppNa] = useState(false);
  const [getApiQuery, setGetApiQuery] = useState(
    userInfo?.lastCustomerRetrievedDate
      ? `updatedAt[gte]=${userInfo?.lastCustomerRetrievedDate}`
      : ""
  );

  const dispatch = useDispatch();

  const filterOptions = ["Not Sent", "All", "Sent"];

  let {
    data: customers,
    isLoading,
    error,
    refetch,
  } = useGetCustomersQuery({
    token: userInfo?.token,
    query: getApiQuery,
  });

  const [updateCustomer] = useUpdateCustomerMutation();

  const submitEdit = async () => {
    try {
      const resData = await updateCustomer({
        _id: editEnabled,
        token: userInfo?.token,
        payload: {
          whatsAppAdStatus: whatsAppAppNa ? "WhatsApp App N/A" : "Sent",
          whatsAppAdSentOn: new Date().toISOString(),
          whatsAppAdTriggered: true,
        },
      }).unwrap();
      if (resData) {
        setStatusUpdate("update done");
        const fromRedux = userInfo?.allCustomers;
        const mergedData = fromRedux?.map((c) => {
          if (c._id === resData?._id) return resData;
          else return c;
        });
        setCustomersToDisplay(mergedData);
        setWhatsAppAppNa(false);
        dispatch(
          setCredentials({
            ...userInfo,
            allCustomers: mergedData,
            lastCustomerRetrievedDate: new Date(
              new Date().getTime() - 2 * 1000 * 60
            ).toISOString(),
          })
        );
        toast.success("Customer Details updated");
      }
    } catch (e) {
      toast.error(e?.data?.error || e.data);
    }
  };

  const hanbdleSubmit = async (user) => {
    setModalShow(true);
  };

  // const handleGetCustomers = async () => {
  //   if (startPincode > endPincode)
  //     toast.error("From Pincode can not be greater than To Pincode");
  //   else {
  //     // setEndDate(getCurrentDate() + getCurrentTime());
  //     if (filterSelect === "Pincode Filter")
  //       setGetApiQuery(
  //         `${filterValue}&pincode[gte]=${startPincode}&pincode[lte]=${endPincode}`
  //       );
  //     else
  //       setGetApiQuery(
  //         `&whatsAppAdSentOn[gte]=${startDate}&whatsAppAdSentOn[lte]=${endDate}T23:59:59.000Z`
  //       );

  //     dispatch(
  //       setCredentials({
  //         ...userInfo,
  //         customersStartPincode: startPincode,
  //         customersEndPincode: endPincode,
  //       })
  //     );
  //   }
  // };

  useEffect(() => {
    if (statusUpdate === "update done") refetch();
  }, [refetch, editEnabled, statusUpdate]);

  useEffect(() => {
    const fromRedux = userInfo?.allCustomers;
    const cusRes = isLoading ? [] : error ? [] : customers ? customers : [];
    if (cusRes.length > 0) {
      const fromRedux = userInfo?.allCustomers;
      const newIds = new Set(cusRes?.map((c) => c._id));
      const unchangedCustomers = fromRedux?.filter((c) => !newIds?.has(c._id));
      const mergedRes = [...unchangedCustomers, ...cusRes];
      const resData = mergedRes?.filter((c) => {
        // 1. Status Filter
        const matchesStatus =
          adStatus === "Sent"
            ? c.whatsAppAdStatus === "Sent"
            : adStatus === "Not Sent"
            ? c.whatsAppAdStatus !== "Sent"
            : true;

        // 2. Date Objects
        const sentDate = new Date(c.whatsAppAdSentOn);
        const sDate = new Date(startDate);
        const eDate = new Date(endDate);

        // Set end date to the end of the day to include all records from that day
        eDate.setHours(23, 59, 59, 999);

        const matchesDate =
          (sentDate >= sDate && sentDate <= eDate) || !c.whatsAppAdSentOn;

        // 3. Pincode (Optional but corrected)
        const matchesPincode =
          Number(c.pincode) >= Number(startPincode) &&
          Number(c.pincode) <= Number(endPincode);

        return matchesStatus && matchesDate && matchesPincode;
      });
      setCustomersToDisplay(resData);
      dispatch(
        setCredentials({
          ...userInfo,
          allCustomers: mergedRes,
          lastCustomerRetrievedDate: new Date(
            new Date().getTime() - 2 * 1000 * 60
          ).toISOString(),
        })
      );
    } else {
      const resData = fromRedux?.filter((c) => {
        // 1. Status Filter
        const matchesStatus =
          adStatus === "Sent"
            ? c.whatsAppAdStatus === "Sent"
            : adStatus === "Not Sent"
            ? c.whatsAppAdStatus !== "Sent"
            : true;

        // 2. Date Objects
        const sentDate = new Date(c.whatsAppAdSentOn);
        const sDate = new Date(startDate);
        const eDate = new Date(endDate);

        // Set end date to the end of the day to include all records from that day
        eDate.setHours(23, 59, 59, 999);

        const matchesDate =
          (sentDate >= sDate && sentDate <= eDate) || !c.whatsAppAdSentOn;

        // 3. Pincode (Optional but corrected)
        const matchesPincode =
          Number(c.pincode) >= Number(startPincode) &&
          Number(c.pincode) <= Number(endPincode);

        return matchesStatus && matchesDate && matchesPincode;
      });
      // toast.warning("No New data available");
      setCustomersToDisplay(resData);
    }
  }, [setCustomersToDisplay, customers, error]);

  useEffect(() => {
    const fromRedux = userInfo?.allCustomers;
    const resData = fromRedux?.filter((c) => {
      // 1. Status Filter
      const matchesStatus =
        adStatus === "Sent"
          ? c.whatsAppAdStatus === "Sent"
          : adStatus === "Not Sent"
          ? c.whatsAppAdStatus !== "Sent"
          : true;

      // 2. Date Objects
      const sentDate = new Date(c.whatsAppAdSentOn);
      const sDate = new Date(startDate);
      const eDate = new Date(endDate);

      // Set end date to the end of the day to include all records from that day
      eDate.setHours(23, 59, 59, 999);

      const matchesDate =
        (sentDate >= sDate && sentDate <= eDate) || !c.whatsAppAdSentOn;

      // 3. Pincode (Optional but corrected)
      const matchesPincode =
        Number(c.pincode) >= Number(startPincode) &&
        Number(c.pincode) <= Number(endPincode);

      return matchesStatus && matchesDate && matchesPincode;
    });
    setCustomersToDisplay(resData);
  }, [adStatus, startDate, endDate, startPincode, endPincode]);

  const hanbdleCancelEdit = () => {
    setEditEnabled(false);
    setWhatsAppAppNa(false);
  };

  return (
    <>
      <Row className="mb-1">
        <label>Gym WhatsApp Ads</label>
      </Row>
      <VerticallyCenteredModal
        title="Are you sure want to submit this ?"
        show={modalShow}
        size="sm"
        onHide={() => setModalShow(false)}
        onSubmit={submitEdit}
        setEdit={setEditEnabled}
      />

      <Row
        className="mb-2"
        style={{
          margin: "auto",
          width: "95%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
          }}
        >
          <Col xs={6} md="auto" sm={6}>
            <Form.Group controlId="visitorMobile">
              <Form.Control
                type="date"
                placeholder="2023-11-23"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              ></Form.Control>{" "}
            </Form.Group>
          </Col>
          <Col xs={6} md="auto" sm={6}>
            <Form.Group controlId="visitorMobile">
              <Form.Control
                type="date"
                placeholder="2023-11-27"
                value={endDate?.split("T")[0]}
                onChange={(e) => setEndDate(e.target.value)}
              ></Form.Control>{" "}
            </Form.Group>
          </Col>
          <Col xs={6} md="auto" sm={6}>
            <Form.Group controlId="visitorMobile">
              <Form.Control
                placeholder="start pincode"
                type="text"
                pattern="[0-9]*" // Allow only digits
                value={startPincode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setStartPincode(value);
                }}
              ></Form.Control>
            </Form.Group>
          </Col>
          <Col xs={6} md="auto" sm={6}>
            <Form.Group controlId="visitorMobile">
              <Form.Control
                placeholder="end pincode"
                type="text"
                pattern="[0-9]*" // Allow only digits
                value={endPincode}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  setEndPincode(value);
                }}
              ></Form.Control>
            </Form.Group>
          </Col>
          {/* <Col
            xs={6}
            md="auto"
            sm={6}
            className="d-flex justify-content-center"
          > */}
          {/* <Form.Group className="my-1" controlId="gymType">
              <Button
                id="filterBy"
                value={filterValue}
                onClick={handleGetCustomers}
              >
                Get Gym WhatsApp Ads
              </Button>
            </Form.Group> */}
          {/* </Col> */}
        </Row>
        <Row
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
            marginTop: "0.5rem",
          }}
        >
          <Col xs={12} md="auto" sm={6}>
            <Form.Group controlId="filterBy">
              <Form.Select
                id="filterBy"
                value={adStatus}
                onChange={(e) => setAdStaus(e.target.value)}
              >
                {filterOptions?.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md="auto" sm={6}>
            <Form.Group as={Row} controlId="visitorMobile">
              <Button style={{ backgroundColor: "#27aa67" }}>
                Total Customers :<strong> {customersToDisplay?.length}</strong>
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Row>
      {isLoading ? (
        <Loader />
      ) : error && !customersToDisplay ? (
        <Message>{error.data.error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive="sm">
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Name</th>
                <th style={{ textAlign: "left" }}>Mobile</th>
                <th style={{ textAlign: "left" }}>Pincode</th>
                <th style={{ textAlign: "left" }}>Message Sent Status</th>
                <th style={{ textAlign: "left" }}>Message Sent Date</th>
                <th style={{ textAlign: "left" }}></th>
                <th style={{ textAlign: "left" }}>WhatsApp App N/A</th>
              </tr>
            </thead>
            <tbody>
              {customersToDisplay ? (
                customersToDisplay?.map((customer) => (
                  <>
                    {editEnabled === customer._id ? (
                      <tr>
                        <td style={{ textAlign: "left", maxWidth: "200px" }}>
                          {customer.gymName}
                        </td>{" "}
                        {/* <td>{customer.pincode}</td> */}
                        <td style={{ textAlign: "left" }}>
                          <a href={`tel:${customer.mobileNumber}`}>
                            {customer.mobileNumber}
                          </a>{" "}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          {customer.pincode}
                        </td>
                        <td style={{ textAlign: "left", maxWidth: "15rem" }}>
                          {customer.whatsAppAdStatus}
                        </td>
                        <td style={{ textAlign: "left", maxWidth: "15rem" }}>
                          {customer.whatsAppAdSentOn?.toString().split("T")[0]}
                        </td>
                        <td>
                          {editEnabled ? (
                            <>
                              <button
                                onClick={hanbdleSubmit}
                                style={{
                                  borderRadius: "10%",
                                  marginLeft: "10px",
                                }}
                              >
                                <CheckLg />
                              </button>
                              <button
                                onClick={hanbdleCancelEdit}
                                style={{
                                  borderRadius: "10%",
                                  margin: "8%",
                                }}
                              >
                                <XLg />
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        {editEnabled && (
                          <td>
                            <Form.Check
                              type="checkbox"
                              label="WhatsApp App N/A"
                              checked={whatsAppAppNa}
                              onChange={(e) => setWhatsAppAppNa(!whatsAppAppNa)}
                            />
                          </td>
                        )}
                      </tr>
                    ) : (
                      <tr>
                        <td style={{ textAlign: "left", maxWidth: "200px" }}>
                          {customer.gymName}
                        </td>{" "}
                        {/* <td>{customer.pincode}</td> */}
                        <td style={{ textAlign: "left" }}>
                          <a href={`tel:${customer.mobileNumber}`}>
                            {customer.mobileNumber}
                          </a>{" "}
                        </td>
                        <td style={{ textAlign: "left" }}>
                          {customer.pincode}
                        </td>
                        <td style={{ textAlign: "left", maxWidth: "15rem" }}>
                          {customer.whatsAppAdStatus}
                        </td>
                        <td style={{ textAlign: "left", maxWidth: "15rem" }}>
                          {customer.whatsAppAdSentOn?.toString().split("T")[0]}
                        </td>
                        <td>
                          {customer.whatsAppAdStatus !== "Sent" && (
                            <button
                              style={{ borderRadius: "20%" }}
                              onClick={() => {
                                setEditEnabled(customer._id);
                              }}
                            >
                              <Pencil />
                            </button>
                          )}
                        </td>
                      </tr>
                    )}
                  </>
                ))
              ) : (
                <Message>No visitors Available</Message>
              )}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};

export default WhatsAppAdsToCustomers;
